// extracted by mini-css-extract-plugin
export default {"tooltip":"MetricDetailsModal_tooltip__LtJBL","title":"MetricDetailsModal_title__Is3-E"};